import React from 'react';
import { TimedealExposureWidgetItem, TimedealWidgetInfo } from '../../../../../../types/widget';
import WidgetPreviewTimedealSwipe from '../WidgetPreviewTimedealSwipeLayout/WidgetPreviewTimedealSwipe';
import { WIDGET_LAYOUT_TYPE, WIDGET_TYPE } from '../../../../../../constants/service/app/widgetConstants';
import WidgetPreviewTimedealInfo from '../WigetPreviewTimedealInfo';
import { NoticeText, NoticeWrapper, PreviewWrapper } from './style';

interface WidgetPreviewTimedealWrapProps {
  widgetInfo: TimedealWidgetInfo;
  exposureWidgetItemList: TimedealExposureWidgetItem[];
}

const WidgetPreviewTimedealWrap = (props: WidgetPreviewTimedealWrapProps): JSX.Element => {
  const { widgetInfo, exposureWidgetItemList } = props;
  const { mainTitle, subTitle, layoutType } = widgetInfo;

  return (
    <PreviewWrapper>
      <NoticeWrapper>
        <NoticeText>※ 타임딜 위젯 미리보기에 노출 되는 금액은 실제 고객들에게 보여지는 금액과 상이합니다.</NoticeText>
        <NoticeText>
          ※ 위젯 미리보기를 통해 배너 이미지 / 메인 타이틀 / 쿠폰 적용 여부에 대해서만 확인 부탁드립니다.
        </NoticeText>
      </NoticeWrapper>
      <WidgetPreviewTimedealInfo title={mainTitle} subTitle={subTitle} />
      {layoutType === WIDGET_LAYOUT_TYPE[WIDGET_TYPE.TIME_DEAL].SWIPE_1_X_N && (
        <WidgetPreviewTimedealSwipe exposureWidgetItemList={exposureWidgetItemList} />
      )}
    </PreviewWrapper>
  );
};

export default WidgetPreviewTimedealWrap;
